/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';
import { cloneState } from '../utils/stateUtils';

const INITIALSTATE = {
    issuance: {},
    allIssuances: {},
    inProgress: false,
};

export default function reservationReducer(state = INITIALSTATE, action) {
    let st = { ...state };

    switch (action.type) {
        case types.GET_ISSUANCE:
            st = cloneState(state);
            st.issuance = action.payload;
            delete st.fetch_err;
            return st;

        case types.GET_ISSUANCE_ERROR:
            st = cloneState(state);
            st.fetch_err = action.error;
            st.fetch_issuance_error = { msg: action.error, code: action.error_code };
            return st;

        case types.GET_ALL_ISSUANCES: {
            st = cloneState(state);
            const resNumber = action.payload.reservation_number;
            st.allIssuances = { ...st.allIssuances, [resNumber]: action.payload };
            delete st.fetch_err;
            return st;
        }

        case types.GET_ALL_ISSUANCES_ERROR:
            st = cloneState(state);
            st.fetch_err = action.error;
            st.fetch_issuance_error = { msg: action.error, code: action.error_code };
            return st;

        case types.GET_ISSUANCE_BY_STATUS:
            st = cloneState(state);
            if (st.issuances === undefined) {
                st.issuances = action.payload;
            } else {
                st.issuances = { ...action.payload, ...state.issuances };
            }
            delete st.fetch_err;
            return st;

        case types.GET_ISSUANCE_BY_STATUS_ERROR:
            st = cloneState(state);
            st.fetch_err = action.error;
            return st;

        case types.POST_ISSUANCE_START:
            st = cloneState(state);
            st.inProgress = true;
            delete st.error;
            return st;

        case types.POST_ISSUANCE:
            st = cloneState(state);
            st.inProgress = false;
            delete st.error;
            return st;

        case types.POST_ISSUANCE_ERROR:
            st = cloneState(state);
            st.inProgress = false;
            st.error = action.payload;
            return st;

        case types.CLEAR_ISSUANCE:
            st = cloneState(state);
            delete st.issuance;
            return st;

        case types.GET_ISSUANCE_PDF_ERROR:
            st = cloneState(state);
            st.fetch_err = action.error;
            return st;
        case types.POST_ISSUANCE_CALCULATE_FEES:
            st = cloneState(state);
            st.issuance_fee_difference = action.payload;
            return st;

        case types.POST_ISSUANCE_CALCULATE_FEES_ERROR:
            st = cloneState(state);
            st.issuance_fee_difference_err = action.error;
            return st;

        case types.POST_ISSUANCE_CARTLESS:
            st = cloneState(state);
            st.issuance = action.payload;
            delete st.error;
            return st;

        case types.POST_ISSUANCE_CARTLESS_ERROR:
            st = cloneState(state);
            st.error = action.error;
            return st;

        case types.GET_USER_ISSUANCES:
            st = cloneState(state);
            st.user_issuances = action.payload;
            delete st.user_issuances_error;
            return st;

        case types.GET_USER_ISSUANCES_ERROR:
            st = cloneState(state);
            st.user_issuances_error = action.error;
            delete st.user_issuances;
            return st;

        case types.UPDATE_ISSUANCE:
            st = cloneState(state);
            st.update_issuance_result = action.payload.status;
            st.updated_issuance = action.payload.issuance;
            delete st.update_issuance_error;
            return st;

        case types.UPDATE_ISSUANCE_ERROR:
            st = cloneState(state);
            st.update_issuance_error = action.error.error;
            delete st.update_issuance_result;
            delete st.updated_issuance;
            return st;

        case types.FINALIZE_CHECKOUT:
            const confirmation = {
                orderID: action.payload.order_id,
                completedReservations: action.payload.completed_reservations,
                subtotal: action.payload.subtotal,
                tax: action.payload.tax,
                total: action.payload.total,
                modification: action.payload.modification,
            };
            st.order_confirmation = confirmation;
            return st;
        default:
            return st;
    }
}
